<template>
  <b-card>
    <loading :active.sync="isLoading" loader="spinner" color="#20A8D8" :is-full-page="false" />

    <template v-slot:header>
      <CIcon name="cil-building" />
      <strong>&nbsp;Companies&nbsp;</strong>
      <small>handles the company registration</small>
    </template>

    <b-card-text>
      <b-row class="mt-2">
        <b-col sm="12" md="3" lg="3">
          <b-button v-b-popover.hover.right="'Toogle to show/hide filter options'" v-b-toggle.collapse-1
            variant="outline-primary">
            FILTER OPTIONS
          </b-button>
        </b-col>
        <b-col sm="12">
          <!-- Collapsible Filter Options -->
          <b-collapse id="collapse-1" class="mt-2">
            <b-card>
              <b-row no-gutters>
                <b-col lg="4" md="6" sm="12" class="mr-2" v-if="loggedUser.type == 'Admin'">
                  <b-form-group label="Company">
                    <v-select class="style-chooser" label="text" :options="companyOptions"
                      :reduce="(company) => company.value" v-model="filterBy.parentCompany">
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          No results found for
                          <em>
                            <strong>{{ search }}</strong></em>.
                        </template>
                        <em style="opacity: 0.5" v-else>Start typing to search for a Company.</em>
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>
                <b-col lg="4" md="6" sm="12" class="mr-2">
                  <b-form-group label="Status">
                    <v-select class="style-chooser" label="text" :options="statusOptions"
                      :reduce="(isActive) => isActive.value" v-model="filterBy.isActive">
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          No results found for
                          <em>
                            <strong>{{ search }}</strong> </em>.
                        </template>
                        <em style="opacity: 0.5" v-else>Start typing to search for status.</em>
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row no-gutters>
                <b-col sm="12">
                  <b-button class="mr-1" variant="success" @click="onFilterRequest">
                    Search
                  </b-button>
                  <b-button class="mr-1" variant="primary" @click="resetFilters">
                    Reset
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>

      <!-- Select Actions and Items Per Page Options -->
      <b-row>
        <b-col sm="6" md="3" class="mt-4 mb-2">
          <b-dropdown text=" Select Actions " variant="dark" slot="append">
            <b-dropdown-item v-b-modal.add-company>Add Company</b-dropdown-item>
            <b-dropdown-item>
              <json-excel :data="exportData" :fields="exportFields" type="xls" :name="fileName + '.xls'">Export in
                Excel</json-excel>
            </b-dropdown-item>
            <b-dropdown-item>
              <json-excel :data="exportData" :fields="exportFields" type="csv" :name="fileName + '.csv'">Export to
                CSV</json-excel>
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col sm="6" md="4" offset-md="5" class="mt-4 mb-2 text-md-right">
          <b-input-group prepend="Show" append="/ Page">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-input-group>
        </b-col>
      </b-row>

      <b-table ref="companiesTable" selectable select-mode="single" :items="items" :fields="fields" :responsive="true"
        selected-variant="primary" :current-page="currentPage" :per-page="perPage">
        <template v-slot:cell(parentCompany)="row">{{
          row.item.parentCompany ? row.item.parentCompany : "None"
        }}</template>
        <template v-slot:cell(actions)="row">
          <CButton color="info" @click="showUpdateModal(row.item)">
            <b>
              <CIcon size="sm" name="cil-pencil" />
            </b>
          </CButton>
        </template>
      </b-table>
    </b-card-text>

    <template v-slot:footer>
      <b-row>
        <b-col md="8" sm="12" class="my-1">
          <span class="totalDisplay">Total: {{ totalRows }}</span>
        </b-col>
        <b-col md="4" sm="12" class="my-1">
          <b-pagination align="right" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>
    </template>

    <!-- Modals here -->
    <AddCompany :allCompaniesObj="allCompaniesObj" />
    <UpdateCompany :allCompaniesObj="allCompaniesObj" />
  </b-card>
</template>

<script>
// Component
import AddCompany from "./companies/AddCompany";
import UpdateCompany from "./companies/UpdateCompany";

// Util
import { DateUtil } from "@/utils/dateUtil";
import { DropDownItemsUtil } from "@/utils/dropDownItemsUtil";

// API
import companyApi from "@/api/companyApi";

// Others
import config from "@/config/env-constants";
import JsonExcel from "vue-json-excel";
import EventBus from "@/shared/event-bus";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import _ from "lodash";

export default {
  name: "setup-companies",
  components: {
    JsonExcel,
    AddCompany,
    UpdateCompany,
    Loading,
  },
  data() {
    return {
      items: [],
      fields: [
        { key: "name", sortable: true },
        { key: "description" },
        { key: "address" },
        { key: "parentCompany" },
        { key: "actions" },
      ],
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      pageOptions: [5, 10, 15, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      selected: [],

      filterBy: {
        parentCompany: { ...config.companyDefaultValue },
        isActive: true,
      },

      allCompaniesObj: {},
      selCompany: {},

      companyOptions: [],
      statusOptions: config.statusOptions,

      loggedUser: this.$store.getters["auth/loggedUser"],
      loggedUserCompany: this.$store.getters["auth/loggedUserCompany"],
      // Check for loader
      isLoading: false,
    };
  },
  computed: {
    /**
     * Returns the set of data to be included in the export. For now this just
     * returns the data as is.
     *
     * @returns {Array} the set of data to be included in the export.
     */
    exportData() {
      return this.items;
    },

    /**
     * Derives the field information based from the data table configuration.
     *
     * @returns {object} the fields to be included in the export.
     */
    exportFields() {
      return {
        Name: "name",
        Description: "description",
        Address: "address",
      };
    },

    fileName() {
      let currTimeStamp = DateUtil.getCurrentTimestamp();
      return `Companies-${DateUtil.getDateInDDMMYYYYHHSSFormat(currTimeStamp)}`;
    },
  },
  async mounted() {
    //  show loading indicator
    this.isLoading = true;

    await this.retrieveData();
    this.companyOptions = DropDownItemsUtil.retrieveCompanyItems(this.allCompaniesObj);

    EventBus.$on("onCloseSaveCompany", (companyObj) =>
      this.updateTable(companyObj)
    );
  },
  methods: {
    updateTable(companyObj) {
      this.allCompaniesObj[companyObj.id] = companyObj;

      // filter
      let filteredObj = { ...this.allCompaniesObj };

      let companyIds = Object.keys(this.allCompaniesObj);
      companyIds.forEach((companyId) => {
        let company = filteredObj[companyId];

        if (
          this.filterBy.parentCompany.id !== null &&
          this.filterBy.parentCompany.id !== company.parentCompanyId &&
          this.filterBy.parentCompany.id !== company.id
        ) {
          delete filteredObj[companyId];
        }

        if (this.filterBy.isActive !== company.isActive) {
          delete filteredObj[companyId];
        }
      });

      filteredObj = _.orderBy(filteredObj, ["name"], ["asc"]);
      this.items = Object.values(filteredObj);
      this.totalRows = this.items.length;
    },

    async onFilterRequest() {
      await this.retrieveData();
    },
    resetFilters() {
      this.filterBy = {
        parentCompany: { ...config.companyDefaultValue },
        isActive: true,
      };
    },
    async retrieveData() {
      try {
        // show loading indicator
        this.isLoading = true;

        let filter = { ...this.filterBy };
        filter.withParentCompany = true;
        filter.companyId = this.loggedUserCompany.id;

        if (this.loggedUser.type === "Admin") {
          const { data } = await companyApi.getCompanies(filter, "Admin");
          this.allCompaniesObj = data.companies;
        } else {
          const { data } = await companyApi.getCompanies(filter, "Manager");
          this.allCompaniesObj = data.companies;
        }

        this.items = Object.values(this.allCompaniesObj);
        this.totalRows = this.items.length;

      } catch (_error) {
        this.$toaster.error("Something went wrong. Please try again.");
      }

      // hide loading indicator
      this.isLoading = false;
    },

    updateSelCompany(item) {
      this.selCompany = item;
      this.$store.commit("company/SET_CURR_COMPANY", item);
      EventBus.$emit("onUpdateSelCompany", item);
    },
    showUpdateModal(item) {
      if (_.isEmpty(item)) {
        this.$toaster.warning("Please select a company to update.");
      } else {
        this.updateSelCompany(item);
        this.$bvModal.show("update-company");
      }
    },
  },

  beforeDestroy() {
    EventBus.$off("onCloseSaveCompany");
  },
};
</script>